
  import { canAddUser, hasPermission, Permissions } from '@/ui/auth/auth';
  import { Button } from '@/ui/components/Button';
  import Level from '@/ui/components/common/Level.vue';
  import AssignedToYou from '@/ui/components/home/AssignedToYou.vue';
  import InProgress from '@/ui/components/home/InProgress.vue';
  import SubmittedForms from '@/ui/components/home/SubmittedForms.vue';
  import SuggestedTemplates from '@/ui/components/home/SuggestedTemplates.vue';
  import YourTemplates from '@/ui/components/home/YourTemplates.vue';
  import WelcomeModal from '@/ui/components/modals/WelcomeModal.vue';
  import { PageTitle } from '@/ui/components/PageTitle';
  import { canIndexChecklists } from '@/ui/helpers';
  import { ChecklistCreateButton } from '@/ui/pages/checklist/ChecklistCreateButton';
  import { defineComponent } from 'vue';

  export default defineComponent({
    components: {
      Button,
      SubmittedForms,
      InProgress,
      AssignedToYou,
      YourTemplates,
      SuggestedTemplates,
      ChecklistCreateButton,
      PageTitle,
      Level,
      WelcomeModal,
    },
    setup() {
      const canManageChecklists = hasPermission(Permissions.MANAGE_CHECKLISTS);
      // TODO: revert this change after the feature suggest templates is implemented and ready to be released
      // 2025-06-24 here and it's still not even started :D
      //const showSuggested = isOnboardingEnabled() && canManageChecklists;
      const showSuggested = false;
      const canViewInspections = hasPermission(Permissions.VIEW_ALL_INSPECTION) || hasPermission(Permissions.VIEW_OWN_INSPECTION);
      const canCreateIssues = hasPermission(Permissions.CREATE_ISSUE);
      const showInProgressOnLeft = !showSuggested && (canIndexChecklists.value || canViewInspections);
      const showInProgressOnRight = !showSuggested && !canIndexChecklists.value && !canViewInspections;
      const showInviteUserButton = hasPermission(Permissions.MANAGE_USERS) && canAddUser();

      return {
        canManageChecklists,
        showSuggested,
        canViewInspections,
        canCreateIssues,
        canAddUser,
        canIndexChecklists,
        showInProgressOnLeft,
        showInProgressOnRight,
        showInviteUserButton,
      };
    },
  });
